<template>
	<div class="pcon">
		<!--  -->
		<div class="pageCon flex">
			<div class="pageConL">
				<leftBox/>
			</div>
			<div class="pageConR">
				<!-- Управление малыми посылками/маркировкой -->
				<div class="listBox f-bct">
					<div class="smallBox">
						<!-- Вкладки -->
						<div class="navBox f-bct">
							<p class="a">Детали посылки</p>
							<p @click="back()">Вернуться назад</p>
						</div>
						<!-- Принадлежащая большая посылка -->
						<div class="bigBagMsg">
							<div class="tit f-bct">
								<div class="tl">
									<div class="bor"></div>
									<p>Детали посылки</p>
								</div>
							</div>
							<div class="bagDetail f-ct">
								<div class="bagimg f-ct">
									<el-image @click="showImgViewer(pmsg.gallery)" v-if="pmsg.gallery.length" :src="pmsg.gallery[0]"></el-image>
									<el-image v-else :src="require('@/static/img4.png')"></el-image>
									<div class="bagimgR f-ct">
										<div class="nubitm">
											<el-image :src="require('@/static/icon17.png')"></el-image>
											<p>Длина：{{pmsg.length||'？'}}см</p>
										</div>
										<div class="nubitm">
											<el-image :src="require('@/static/icon18.png')"></el-image>
											<p>Ширина：{{pmsg.width||'？'}}см</p>
										</div>
										<div class="nubitm">
											<el-image :src="require('@/static/icon19.png')"></el-image>
											<p>Высота：{{pmsg.height||'？'}}см</p>
										</div>
										<div class="nubitm">
											<el-image :src="require('@/static/icon20.png')"></el-image>
											<p>Объем：{{pmsg.volume||'？'}}см³</p>
										</div>
										<div class="nubitm">
											<el-image :src="require('@/static/icon21.png')"></el-image>
											<p>Вес：{{pmsg.weight||'？'}}кг</p>
										</div>
										<div class="nubitm">
											<el-image :src="require('@/static/icon22.png')"></el-image>
											<p>Количество：{{pmsg.miniPackageNum||'？'}}шт</p>
										</div>
										<div class="nubitm">
											<el-image :src="require('@/static/icon32.png')"></el-image>
											<p>Плотность：{{pmsg.density||'？'}}КГ/м³</p>
										</div>
										<div class="anniu" @click="link('/carMsg',{id:pmsg.train.id})">Просмотр поезда</div>
										
										<div class="nubitm" v-if="pmsg.transportType" style="width: 100%;margin-top: 0.06rem;">
											<p>тип доставк：{{pmsg.transportType}}</p>
										</div>
										<div class="nubitm" v-if="pmsg.freightType" style="width: 100%;margin-top: 0.03rem;">
											<p>быстрая：{{pmsg.freightType}}</p>
										</div>
										<div class="nubitm" v-if="pmsg.insurance" style="width: 100%;margin-top: 0.03rem;">
											<p>Застраховать：${{pmsg.insurance}}</p>
										</div>
										
									</div>
								</div>
								<div class="bagCar">
									<div class="bagCarItm" v-if="pmsg.status != 2">
										<p class="t1">Упаковщик<span>：</span></p>
										<div class="t2">
											<el-image v-if="pmsg.packerPortrait" :src="pmsg.packerPortrait"></el-image>
											<el-image v-else :src="require('@/static/img1.png')"></el-image>
											<p>{{pmsg.packerName}}</p>
										</div>
									</div>
									<div class="bagCarItm">
										<p class="t1">Способ упаковки<span>：</span></p>
										<div class="t2">
											<p>{{pmsg.packType}}</p>
										</div>
									</div>
									<div class="bagCarItm" v-if="pmsg.remark">
										<p class="t1">Примечание к упаковке<span>：</span></p>
										<div class="t2">
											<p>{{pmsg.remark}}</p>
										</div>
									</div>
									<div class="bagCarItm" v-if="pmsg.packTime">
										<p class="t1">Время упаковки<span>：</span></p>
										<div class="t2">
											<p>{{pmsg.packTime}}</p>
										</div>
									</div>
									<div class="bagCarItm" v-if="pmsg.predictTime">
										<p class="t1">Предполагаемое время отправки<span>：</span></p>
										<div class="t2">
											<p>{{pmsg.predictTime}}</p>
										</div>
									</div>
									<div class="bagCarItm" v-if="pmsg.sendTime">
										<p class="t1">Время отправки<span>：</span></p>
										<div class="t2">
											<p>{{pmsg.sendTime}}</p>
										</div>
									</div>
									<div class="bagCarItm" v-if="pmsg.predictArriveTime">
										<p class="t1">Предполагаемое время доставки<span>：</span></p>
										<div class="t2">
											<p>{{pmsg.predictArriveTime}}</p>
										</div>
									</div>
									<div class="bagCarItm">
										<p class="t1" style="color: red;">груз<span>：</span>Страхование（{{pmsg.premium}}）+ цена за единицу（{{pmsg.price}}）* вес / объем（{{pmsg.weightOrVolume}}）+ стоимость упаковки（{{pmsg.packingPrice}}）= ${{pmsg.freight}}</p>
									</div>
								</div>
							</div>
						</div>
						<!-- Список -->
						<div class="smallList">
							<div class="itm" v-for="(item,index) in packageMiniList">
								<div class="sn f-bct">
									<div class="t1 f-ct">
										Номер：<span>{{item.expressNumber}}</span>
										<template>
											<p class="borMT"></p>
											<div class="manMT">Маркировка：{{item.memberCode||'？'}}</div>
										</template>
									</div>
									<div class="t2" v-if="item.status==0">Не на складе</div>
									<div class="t2" v-if="item.status==1">На складе</div>
									<div class="t2" v-if="item.status==2">Готов к упаковке</div>
									<div class="t2" v-if="item.status==3">Упаковано</div>
									<div class="t2" v-if="item.status==4">Отправлено</div>
									<div class="t2" v-if="item.status==5">Доставлено</div>
								</div>
								<div class="detail f-ct">
									<div class="msg f-ct">
										<el-image class="img" @click="showImgViewer([item.imageUrl])" v-if="item.imageUrl" :src="item.imageUrl"></el-image>
										<el-image class="img" v-else :src="require('@/static/img4.png')"></el-image>
										<div class="r f-ct">
											<div class="cBox f-ct">
												<div class="nubitm">
													<el-image :src="require('@/static/icon17.png')"></el-image>
													<p>Длина：{{item.length||'？'}}см</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon18.png')"></el-image>
													<p>Ширина：{{item.width||'？'}}см</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon19.png')"></el-image>
													<p>Высота：{{item.height||'？'}}см</p>
												</div>
												<div class="nubitm">
													<p>имя：{{item.name||'？'}}</p>
												</div>
											</div>
											<div class="cBox f-ct">
												<div class="nubitm">
													<el-image :src="require('@/static/icon20.png')"></el-image>
													<p>Объем：{{item.volume||'？'}}см³</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon21.png')"></el-image>
													<p>Вес：{{item.weight||'？'}}кг</p>
												</div>
												<div class="nubitm">
													<el-image :src="require('@/static/icon22.png')"></el-image>
													<p>Мелкие предметы：{{item.pieceNum}}шт</p>
												</div>
											</div>
										</div>
									</div>
									<div class="bor"></div>
									<div class="caozuo">
										<p class="t1" @click="link('/smallBagMsg',{id:item.id})">Просмотр деталей</p>
										
										<p class="t1" style="margin-top: 0.06rem;font-size: 0.12rem;" v-if="item.lookDetailStatus==0" @click.stop="applyLookDetailF(item.id)">Запрос на просмотр пакета</p>
										<p class="t1" style="margin-top: 0.06rem;font-size: 0.12rem;" v-if="item.lookDetailStatus==1">Подать заявку на просмотр пакета</p>
										<p class="t1" style="margin-top: 0.06rem;font-size: 0.12rem;" v-if="item.lookDetailStatus==2" @click.stop="showImgViewer(item.lookDetailGallery)">Посмотреть пакет</p>
										
									</div>
								</div>
							</div>
						</div>
						<!-- <div class="delBag">Удалить заказ</div> -->
						<!--  -->
					</div>
				</div>
			</div>
		</div>
		<!-- Просмотр изображения -->
		<el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
	</div>
</template>
<script>
	import { packageBigDetail,applyLookDetail } from "/src/api/api.js"
	import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
	export default {
		components: {
			'leftBox': () => import('@/components/leftBox.vue'),
			'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
		},
		data(){
			return {
				imgViewerVisible:false,
				imgList:[],

				id:0,
				pmsg:'',
				packageMiniList:[],
				train:[],
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.packageBigDetail()
		},
		methods:{
			// 申请查看包裹
			async applyLookDetailF(id){
				const res = await applyLookDetail({id})
				if(res.code==200){
					this.Tips(res.msg,'success')
					this.packageBigDetail()
				}else{this.Tips(res.msg)}
			},
			// Просмотр изображения
			showImgViewer(arr){
				this.imgList = arr
				this.imgViewerVisible = true;
				const m = (e) => { e.preventDefault() };
			},
			closeImgViewer(){
				this.imgViewerVisible = false;
			},
			// Получить детали большой посылки
			async packageBigDetail(){
				const res = await packageBigDetail({id:this.id})
				if(res.code==200){
					this.pmsg = res.data
					this.packageMiniList = res.data.packageMiniList
					this.train = res.data.train
				}else{this.Tips(res.msg)}
			},
		},
		computed:{
			...mapState('userMsg',['userInfo']),
		}
	}
</script>
<style lang="scss">
	body{
		// background: #f6f7fb;
	}
</style>
<style lang="scss" scoped>
	.pcon{
		padding: 0 74px;
		padding-bottom: 46px;
	}
	.banner{
		width: 100%;
		height: 413px;
		.el-image{
			width: 100%;
			height: 413px;
			border-radius: 18px;
		}
		.dian{
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			bottom: 16px;
			z-index: 2;
			div{
				margin: 0 3px;
				width: 8px;
				height: 8px;
				border-radius: 8px;
				background: #00000033;
				transition:0.3s;
			}
			.a{
				background: #fff;
				width: 14px;
				transition:0.3s;
			}
		}
	}
	.delBag{
		width: 140px;
		height: 42px;
		border: 1px solid #DDDDDD;
		font-size: 16px;
		color: #666666;
		text-align: center;
		line-height: 40px;
		cursor: pointer;
		border-radius: 6px;
		background: #FF4D5A;
		border: 1px solid #FF4D5A;
		color: #fff;
		// margin-right: 12px;
		margin-top: 12px;
		margin-left: 1020px;
	}
	.pageCon{
		margin-top: 32px;
		justify-content: space-between;
		.pageConL{
			width: 530px;
		}
		.pageConR{
			width: calc(100% - 562px);
			.userNub{
				.itm{
					width: 382px;
					height: 158px;
					border-radius: 12px;
					background: #fff;
					padding-right: 46px;
					padding-left: 36px;
					.el-image{
						width: 80px;
					}
					.txt{
						width: calc(100% - 90px);
						margin-right: 10px;
						.t1{
							font-size: 42px;
							font-weight: bold;
						}
						.t2{
							font-size: 20px;
							color: #666666;
						}
					}
				}
			}
			.listBox{
				.tit{
					.tl{
						display: flex;
						align-items: center;
						.bor{width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;}
						p{
							font-size: 18px;
							padding-left: 10px;
						}
					}
					.tr{
						display: flex;
						align-items: center;
						.el-image{
							width: 20px;
						}
						p{
							font-size: 16px;
							color: #666666;
						}
					}
				}
				.zw{
					padding-top: 0;
					.el-image{
						margin-bottom: 0;
					}
				}
				.smallBox{
					width: 100%;
					// height: 411px;
					background: #fff;
					border-radius: 12px;
					padding: 24px;
					.smallList{
						margin-top: 16px;
						// height: 340px;
						// background: pink;
						// overflow: scroll;
						.itm{
							border: 1px solid #EFF1F6;
							border-radius: 8rpx;
							margin-bottom: 16px;
							.sn{
								height: 56px;
								border-bottom: 1px solid #EFF1F6;
								background: #EFF1F6;
								padding: 0 24px;
								.el-image{
									display: block;
									width: 20px;
									margin-right: 12px;
									// margin-left: 24px;
								}
								.t1{
									font-size: 16px;
									color: #999999;
									span{
										color: #333;
									}
								}
								.t3{
									.snTxt{
										font-size: 16px;
										color: #999999;
										span{
											color: #333;
										}
									}
									.bor{
										width: 1px;
										height: 16px;
										background: #D9D9D9;
										margin: 0 24px;
									}
									.man{
										font-size: 16px;
									}
								}
								.t2{
									padding: 0 6px;
									// width: 72px;
									height: 30px;
									background: #C7F3F5;
									font-size: 14px;
									color: #38ABB0;
									text-align: center;
									line-height: 30px;
									border-radius: 4px;
								}
							}
							.detail{
								padding: 16px 0;
								.msg{
									width: calc(100% - 105px);
									padding-left: 24px;
									// background: pink;
									.img{
										width: 66px;
										height: 66px;
										border-radius: 6px;
										margin-right: 16px;
									}
									.r{
										width: calc(100% - 82px);
										.cBox{
											margin-bottom: 10px;
											&:last-child{
												margin-bottom: 0;
											}
										}
										.nubitm{
											display: flex;
											align-items: center;
											// margin-right: 63px;
											width: 176px;
											.el-image{
												width: 20px;
												height: 20px;
												margin-right: 6px;
											}
											p{
												font-size: 16px;
											}
										}
									}
								}
								.bor{
									width: 1px;
									height: 50px;
									background: #D9D9D9;
								}
								.caozuo{
									width: 104px;
									// background: #00000033;
									p{
										text-align: center;font-size: 16px;
										cursor: pointer;
									}
									.t1{
										color: #38ABB0;
									}
									.t2{
										color: #FF4D5A;
										margin-top: 6px;
									}
									.t3{
										color: #38ABB0;
										margin-top: 6px;
									}
								}
							}
						}
					}
				}
				.mtBox{
					width: 382px;
					height: 411px;
					background: #fff;
					border-radius: 12px;
					padding: 24px;
					.maitouList{
						margin-top: 16px;
						height: 330px;
						// background: pink;
						overflow: scroll;
						.mtItm{
							margin-bottom: 22px;
							.l{
								.nub{
									// width: 20px;
									height: 20px;
									background: #38ABB0;
									margin-right: 12px;
									color: #fff;
									border-radius: 20px;
									font-size: 13px;
									text-align: center;
									line-height: 19px;
									padding: 0 5px;
									padding-left: 6px;
								}
								.el-image{
									width: 45px;
								}
								p{
									font-size: 16px;
									padding-left: 6px;
								}
							}
							.r{
								display: flex;
								align-items: center;justify-content: flex-end;
								.bor{
									width: 1px;
									height: 16px;
									margin: 0 10px;
									background: #D9D9D9;
								}
								.btnItm{
									display: flex;
									align-items: center;
									.el-image{
										width: 14px;
										margin-right: 4px;
									}
									p{
										font-size: 14px;
									}
									.t1{
										color: #38ABB0;
									}
									.t2{
										color: #FF4D5A;
									}
								}
							}
						}
					}
					.tableImgList{
						margin-top: 16px;
						height: 340px;
						// background: pink;
						overflow: scroll;
						.el-image{
							width: 100%;
							height: 154px;
							margin-bottom: 16px;
							border-radius: 12px;
						}
					}
				}
			}
		}
	}
	.shaixuan{
		padding: 0 24px;
		padding-top: 24px;
		margin-bottom: 24px;
		padding-left: 0;
		.l{
			.itm{
				display: flex;
				align-items: center;
				font-size: 16px;
				margin-right: 31px;
				span{
					display: block;
					width: 90px;
					padding-right: 16px;
				}
			}
			.itm1{
				display: flex;
				align-items: center;
				font-size: 16px;
				margin-right: 31px;
				border: 1px solid #DDDDDD;
				border-radius: 4px;
				span{
					display: block;
					width: 90px;
					padding-right: 16px;
				}
				::v-deep .el-input__inner{
					background: none;
					border: none;
					padding-left: 0;
				}
				.el-image{
					display: block;
					width: 16px;
					margin-left: 16px;
					margin-right: 12px;
				}
			}
		}
		.seachBtn{
			transform: translateX(-12px);
			div{
				width: 85px;
				height: 40px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 38px;
				cursor: pointer;
				border-radius: 6px;
				&:first-child{
					background: #38ABB0;
					border: 1px solid #38ABB0;
					color: #fff;
					margin-right: 12px;
				}
			}
		}
	}
	.rukuSel{
		.l{
			.el-image{
				width: 20px;
				margin-right: 12px;
			}
			span{
				font-size: 14px;
			}
		}
		.seachBtn{
			p{
				font-size: 14px;
				padding-right: 16px;
			}
			div{
				width: 128px;
				height: 40px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 38px;
				cursor: pointer;
				border-radius: 6px;
				background: #38ABB0;
				border: 1px solid #38ABB0;
				color: #fff;
				margin-right: 12px;
			}
		}
	}
	.navBox{
		border-bottom: 1px solid #EEEEEE;
		// padding: 0 10px;
		p{
			// padding-top: 24px;
			padding-bottom: 16px;
			// margin-right: 56px;
			font-size: 18px;
			cursor: pointer;
			color: #7D7D89;
			&::after{
				position: absolute;
				content: '';
				width: 0%;
				height: 4px;
				border-radius: 4px;
				background: #38ABB0;
				bottom: 0%;
				left: 50%;
				transform: translateX(-50%);
				transition:0.3s;
			}
		}
		.a{
			color: #38ABB0;
			font-weight: bold;
			&::after{
				width: 100%;
				transition:0.3s;
			}
		}
	}
	.bigBagMsg{
		margin-top: 24px;
		border-radius: 10px;
		border: 1px solid #EEEEEE;
		padding-top: 24px;
		padding-bottom: 36px;
		.tit{
			padding-bottom: 20px;
			.tl{
				display: flex;
				align-items: center;
				.bor{width: 2px;height: 15px;background: #38ABB0;border-radius: 2px;}
				p{
					font-size: 18px;
					padding-left: 10px;
					font-weight: bold;
				}
			}
			.tr{
				display: flex;
				align-items: center;
				.el-image{
					width: 20px;
				}
				p{
					font-size: 16px;
					color: #666666;
				}
			}
		}
		.bagDetail{
			.bagimg{
				width: 572px;
				border-right: 1px solid #EBEEF5;
				padding-left: 24px;
				.el-image{
					width: 182px;
					height: 182px;
					border-radius: 6px;
					margin-right: 20px;
				}
				.bagimgR{
					width: calc(100% - 202px);
					.nubitm{
						display: flex;
						align-items: center;
						// margin-right: 63px;
						width: 164px;
						margin-bottom: 15px;
						.el-image{
							width: 20px;
							height: 20px;
							margin-right: 6px;
						}
						p{
							font-size: 16px;
						}
					}
					.anniu{
						width: 108px;
						height: 42px;
						border: 1px solid #DDDDDD;
						font-size: 16px;
						color: #666666;
						text-align: center;
						line-height: 38px;
						cursor: pointer;
						border-radius: 6px;
						background: #38ABB0;
						border: 1px solid #38ABB0;
						color: #fff;
						margin-right: 12px;
					}
				}
			}
			.bagCar{
				padding-left: 48px;
				width: calc(100% - 572px);
				// background: pink;
				padding-right: 30px;
				.bagCarItm{
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 100%;
					margin-bottom: 10px;
					// background: pink;
					.t1{
						position: relative;
						font-size: 16px;
						// span{
						// 	position: absolute;
						// }
					}
					.t2{
						font-size: 16px;
						display: flex;
						align-items: center;
						.el-image{
							width: 20px;
							height: 20px;
							border-radius: 50%;
							margin-right: 6px;
						}
					}
				}
			}
		}
		.bagDetail1{
			padding: 0 28px;
			.bagCar1{
				// width: 50%;
				width: 495px;
				// padding-left: 48px;
				// width: calc(100% - 572px);
				// background: pink;
				// padding-right: 30px;
				.bagCarItm{
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 100%;
					margin-bottom: 12px;
					// background: pink;
					.t1{
						position: relative;
						font-size: 16px;
						// span{
						// 	position: absolute;
						// }
					}
					.t2{
						font-size: 16px;
						display: flex;
						align-items: center;
						.el-image{
							width: 20px;
							height: 20px;
							border-radius: 50%;
							margin-right: 6px;
						}
					}
				}
			}
		}
	}
</style>